import { Injectable, Type } from '@angular/core';
import { BaseFlowsService } from '@kinet-open-network/client/flows/data-access';
import {
  FlowGoodsReceipts,
  FlowGoodsReceiptsStepData,
} from './flow-goods-receipts.model';

@Injectable({ providedIn: 'root' })
export class FlowGoodsReceiptsService extends BaseFlowsService<
  FlowGoodsReceipts,
  'id',
  FlowGoodsReceiptsStepData
> {
  override readonly flowType = 'goods-receipt';
  override model: Type<FlowGoodsReceipts> = FlowGoodsReceipts;
  override stepDataClass: Type<FlowGoodsReceiptsStepData> =
    FlowGoodsReceiptsStepData;
}
